import styled from "styled-components";

const pi = 3.14;
const backgroundColor = "#e8e8e9";
const foregroundColor = "#52accb";
const labelFontSize = "2.5rem";
const duration = "3s";
const strokeWidth = 25;
const animationDelay = "1s";

const CircularChart = styled.figure`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  margin: 0;
  position: relative;
  svg {
    width: 100%;
    height: 100%;
    .circle-background {
      r: ${(props) => (props.size - strokeWidth) / 2};
      cx: 50%;
      cy: 50%;
      fill: none;
      stroke: ${backgroundColor};
      stroke-width: ${strokeWidth}px;
    }
    .circle-foreground {
      r: ${(props) => (props.size - strokeWidth) / 2};
      cx: 50%;
      cy: 50%;
      fill: none;
      stroke-width: ${strokeWidth}px;
      stroke: ${foregroundColor};
      stroke-dasharray: ${(props) =>
          (props.percentage / 100) * ((props.size - strokeWidth) * pi)}
        ${(props) => (props.size - strokeWidth) * pi};
      stroke-dashoffset: ${(props) =>
        (props.percentage / 100) * ((props.size - strokeWidth) * pi)};
      transform-origin: 50% 50%;
      transform: rotate(-90deg);
    }
  }
  figcaption {
    display: inline-block;
    width: 100%;
    height: ${labelFontSize};
    overflow: hidden;
    text-align: center;
    position: absolute;
    top: calc(50% - #{${labelFontSize} / 2});
    left: 0;
    font-size: 0;
  }
  svg .circle-foreground {
    animation: offset ${duration} ease-in-out forwards;
    animation-delay: ${animationDelay};
  }
  figcaption:after {
    animation: circular-chart-label ${duration} ${(props) => props.percentage}
      forwards;
    animation-delay: ${animationDelay};
  }
  @keyframes circular-chart-label {
    100% {
      transform: translateY(2.5rem * (-(${(props) => props.percentage})));
    }
  }
`;
export default CircularChart;
